import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import Header from 'common/js/header/header.js'
import DisplayPlanListTable from './DisplayPlanListTable'
import { getPtmPlanSettingSvc } from './displayPlanSvc'

function DisplayPlanCtrl() {
  const [loader, setLoader] = useState('none')
  const search = useLocation().search
  const [ptmId, setPtmId] = useState(new URLSearchParams(search).get('ptmId'))
  const [flgSlider, setFlgSlider] = useState(0)
  const [lstPtmSetting, setLstPtmSetting] = useState([])

  useEffect(() => {
    getPtmSetting()
  }, [])

  const getPtmSetting = () => {
    getPtmPlanSettingSvc(ptmId, cbPtmPlanSetting);
  }
  const cbPtmPlanSetting = (data) => {
    if (data.status == "Success") {
      setLstPtmSetting(data.lstPtmSetting)
    } else {
      toast.error(data.message)
    }
  }
  const getWingId = wingId => {
    // console.log('wingId = ' + wingId)
  }
  return (

    <div className='MainContainer'>
      <div
        style={{
          position: 'fixed',
          zIndex: 10000,
          width: 100,
          height: 100,
          marginLeft: -50,
          marginTop: -50,
          left: '50%',
          top: '50%',
          display: loader
        }}
      >
        <img
          className='loderImg'
          src={require('common/images/loader.gif')}
          alt='Loader...'
        />
      </div>
      <Header wingFromChild={getWingId} />
      <ToastContainer autoClose={3000} hideProgressBar />
      <div className='col-sm-6 col-centered' style={{ top: '2%' }}>
        {lstPtmSetting && lstPtmSetting.length > 0 &&
          <DisplayPlanListTable
            setFlgSlider={setFlgSlider}
            lstPtmSetting={lstPtmSetting}
            ptmId={ptmId}
          />}

      </div>
    </div>
  )
}


export default DisplayPlanCtrl